import { useQuery } from "@tanstack/react-query";
import { sidebarService } from "../services/sidebarService";
import { useTranslation } from "react-i18next";

export const useDrawerNav = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language?.split("-")[0] ?? "tr";
  return useQuery({
    queryKey: ["sidebar", "drawerNav", lang],
    queryFn: sidebarService.getDrawerNav,
    staleTime: 1000 * 60 * 10,
    select: (data) => (Array.isArray(data) ? data : []),
  });
};

export const useSocialLinks = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language?.split("-")[0] ?? "tr";
  return useQuery({
    queryKey: ["sidebar", "socialLinks", lang],
    queryFn: sidebarService.getSocialLinks,
    staleTime: 1000 * 60 * 10,
    select: (data) => (Array.isArray(data) ? data : []),
  });
};
